import * as appDefIds from '@wix/app-definition-ids'
import { Box, Heading, Text } from '@wix/design-system'
import React, { FC, Fragment, useEffect } from 'react'

import { fedopsLogger } from '../../monitoring/fedops'
import { spaceConfigs } from './spaceConfigs'
import { useLoadMetaSites } from './useLoadMetaSites'

export const Preview: FC = () => {
  const [metaSitesState] = useLoadMetaSites()
  const params = new URLSearchParams(window.location.search)
  const spaceId = params.get('spaceId') ?? undefined
  const flowId = params.get('flowId') ?? undefined

  const { getProjectName, getMetaSiteLink } = spaceConfigs[spaceId || 'default'] || spaceConfigs.default

  useEffect(() => {
    fedopsLogger.appLoaded()
  }, [])

  // TODO: add loading state?
  const metaSites = metaSitesState.type === 'ready' ? metaSitesState.metaSites : []

  return (
    <Box direction="vertical" align="center">
      <Box width="800px" direction="vertical" marginTop="SP8" gap="SP2">
        <Heading>Select meta site for {getProjectName()} preview</Heading>
        <Text secondary>
          Please do not use any production meta sites, as intro can do persistence and you can unintentionally break
          production. Thank you!
        </Text>
        {metaSites.map(metaSite => (
          <Fragment key={metaSite.metaSiteId}>
            <Box padding="SP2 0" borderBottom="1px solid #DFE5EB" direction="vertical">
              <Text>
                <a href={getMetaSiteLink(metaSite, flowId)}>
                  {metaSite.siteProperties?.siteDisplayName || metaSite.name || metaSite.metaSiteId || 'weird site'}
                </a>
              </Text>
              <Text secondary size="small">
                Apps:{' '}
                {metaSite.apps
                  ?.map(app => appIdToName(app.appDefId!))
                  .filter(i => i)
                  .join(', ') || 'Only technical'}
              </Text>
            </Box>
          </Fragment>
        ))}
      </Box>
    </Box>
  )
}

const hiddenApps: Record<string, true> = {
  WIX_CODE_SECRETS_MANAGER: true,
  SITE_MEMBERS: true,
}
const lookup: Record<string, string> = {}
Object.keys(appDefIds).forEach(key => {
  if (hiddenApps[key]) {
    return
  }
  const reverseKey = (appDefIds as any)[key] as string
  lookup[reverseKey] = key
})
const appIdToName = (appDefId: string) => {
  return lookup[appDefId]
}
